export const NEXT_SEGMENT = 'NEXT_SEGMENT';
export const PREV_SEGMENT = 'PREV_SEGMENT';
export const NEXT_PAGE = 'NEXT_PAGE';
export const PREV_PAGE = 'PREV_PAGE';

export const nextSegment = (currentSegmentName, payload, sessionId) => ({
  type: NEXT_SEGMENT,
  currentSegmentName,
  payload,
  sessionId,
});

export const prevSegment = (currentSegmentName, payload) => ({
  type: PREV_SEGMENT,
  currentSegmentName,
  payload,
});

export const nextPage = (currentSegmentName, payload) => ({
  type: NEXT_PAGE,
  currentSegmentName,
  payload,
});

export const prevPage = (currentSegmentName, payload) => ({
  type: PREV_PAGE,
  currentSegmentName,
  payload,
});
